var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgNoteStack = function SvgNoteStack(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 30 30",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "note_stack_svg__a",
    width: 30,
    height: 30,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#note_stack_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.375 24.615v-13q0-.934.672-1.587a2.23 2.23 0 0 1 1.607-.653h12.961q.935 0 1.598.662.662.662.662 1.598v8.415q0 .452-.176.87-.175.417-.483.724l-4.572 4.572a2.2 2.2 0 0 1-.725.483 2.2 2.2 0 0 1-.869.176h-8.415q-.936 0-1.598-.662a2.18 2.18 0 0 1-.662-1.598M3.156 8.03q-.175-.936.365-1.685.539-.75 1.474-.926L17.79 3.156q.935-.175 1.685.365.75.539.925 1.474l.288 1.64h-9.052q-2.062 0-3.532 1.468-1.468 1.47-1.468 3.532v10.831a2.4 2.4 0 0 1-.794-.672 2.17 2.17 0 0 1-.423-.972zM25 20h-3.87q-.483 0-.806.323a1.1 1.1 0 0 0-.324.807V25z"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgNoteStack);
export default ForwardRef;